// Exports: PriorityBadge
import React from "react";
import clsx from "clsx";

const PriorityBadge = ({ value }) => (
  <span
    className={clsx(
      "px-3 xl:px-6 py-1 rounded-md text-xs xl:text-sm inline-flex items-center w-full font-normal flex-row justify-center",
      value === "High"
        ? "bg-red-100 text-red-800 hover:bg-red-200"
        : value === "Medium"
          ? "bg-yellow-100 text-yellow-800 hover:bg-yellow-200"
          : "bg-green-100 text-green-800 hover:bg-green-200"
    )}
    style={{
      gap: "0.5rem",
    }}
  >
    <span
      className={clsx(
        "w-1.5 h-1.5 xl:w-2 xl:h-2 rounded-full",
        value === "High"
          ? "bg-red-500"
          : value === "Medium"
            ? "bg-yellow-500"
            : "bg-green-500"
      )}
    />
    {value}
  </span>
);

export default PriorityBadge;
